import { gql, TypedDocumentNode } from "@apollo/client";

import { Run } from "types/generated";

type StopRunData = {
  runStop: Pick<Run, "id">;
};

type StopRunVariables = {
  stackId: string;
  runId: string;
};

export const STOP_RUN: TypedDocumentNode<StopRunData, StopRunVariables> = gql`
  mutation StopRunNext($stackId: ID!, $runId: ID!) {
    runStop(stack: $stackId, run: $runId) {
      id
    }
  }
`;
